import React from "react";
import { DistrictBackground } from "assets/js/Styles";
import Navbar from "./navbar";

const Layout4 = ({ children }) => {
  return (
    <DistrictBackground>
      <Navbar />
      {children}
    </DistrictBackground>
  );
};

export default Layout4;
